import React from 'react';

import styles from './BlueUnderlineButton.module.css';

export const BlueUnderlineButton = ({
  className = '',
  onClick = () => { },
  title = '',
}) => (
  <button
    className={`${styles.button} ${className}`}
    onClick={onClick}
    type="button"
  >
    {title}

    <div className={styles.underline} />
  </button>
);
